import type {
  FrontendAssortmentDimensionAttributeAggregation,
  FrontendAssortmentRowDimensionIdentifier,
  GetPreSeasonAggregationsListBody,
} from '../types';

import { isConcreteDimensionIdentifier } from './map-row-dimension-to-identifier';
import { transformDimensionAttributes } from './transform-dimensions';

type RequestBody = Omit<
  GetPreSeasonAggregationsListBody,
  'dimensions' | 'include_list'
> & {
  dimensions: FrontendAssortmentDimensionAttributeAggregation;
  include_list?: FrontendAssortmentRowDimensionIdentifier[][];
};

export const transformPreSeasonAggregationsRequest = (
  body: RequestBody,
): GetPreSeasonAggregationsListBody => {
  const { dimensions, include_list, ...rest } = body;
  const transformedDimensions = transformDimensionAttributes(dimensions);
  return {
    ...rest,
    dimensions: transformedDimensions,
    ...(include_list?.length
      ? {
          include_list: include_list.map((row) =>
            row.filter(isConcreteDimensionIdentifier),
          ),
        }
      : {}),
  };
};
